// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xX7e1","description":"styles_description__x2df2"};